<!-- 查看/编辑权威指南弹窗 -->
<template>
    <div>
        <el-dialog title="查看详情" :visible.sync="isShowCheck" top="100px" width="30%" custom-class="custom-dialog-class"
            @close="closeDialog">
            <div v-loading="isLoading" class="dialog-container">
                <el-form label-width="120px">
                    <el-form-item label="指南名称：" prop="guideName">
                        <span>{{ this.contentObj.guideName }}</span>
                    </el-form-item>
                    <el-form-item label="文章内容：" prop="guideContent">
                        <a :href="`${this.contentObj.guideContent}`" target="_blank">{{`${this.contentObj.guideName}.pdf`}}</a>
                    </el-form-item>
                </el-form>
            </div>
            <template #footer>
                <slot></slot> 
            </template>
        </el-dialog>
        <AuthoritativeGuideAddDialog :value="isShowEdit" :contentId="contentObj.id" :id="rowId" :guideName="contentObj.guideName"
            :guideContent="contentObj.guideContent" :closeDialog="closeDialog"  @reEditCommit="reEditCommit" operType="reEdit" titleProp="重新提交">
            <template v-slot:default="slotProps">
                <el-button type="primary" @click="slotProps.confirm_handler">重新提交</el-button>
                <el-button @click="closeDialog">取 消</el-button>
            </template>
        </AuthoritativeGuideAddDialog>
    </div>
</template>

<script>
import { post } from "@/api/http";
import AuthoritativeGuideAddDialog from '../AuthoritativeGuide/components/AuthoritativeGuideAddDialog';
export default {
    name: 'AuthoritativeGuideDialog',
    components: {
        AuthoritativeGuideAddDialog
    },
    props: {
        operType: {
            type: String,
            default: "check",
        },
        closeDialog: {
            type: Function,
            default: () => { },
        },
        content: {
            type: String,
            default: "",
        },
        rowId: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            contentObj: JSON.parse(this.content || "{}"),
        }
    },
    computed: {
        isShowCheck() {
            return this.operType === "check";
        },
        isShowEdit() {
            return this.operType === "edit";
        },
    },
    methods: {
        async reEditCommit(content = {}) {
            try {
                const params = {
                    id: this.rowId,
                    content: JSON.stringify(content)
                }
                const result = await post("/diet/audit/reSubmit", params);
                const { code } = result;
                if (code === "SUCCESS") {
                    this.$message.success("提交成功");
                    this.closeDialog(); // 关闭弹窗
                    this.$emit('fetchTableList');
                } else {
                    this.$message.error("提交失败，请重试！");
                }
            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>
<style lang="scss" scoped></style>
